import SLSItemExClient from '@/api/SistemaDKP/sls-item-ex.client';
import { ErrorMessage } from '@/libs/Error';
import Notifier from '@/libs/Notifier';

export default class SLSitemExService {
  constructor() {
    this.client = new SLSItemExClient();
    this.error = new ErrorMessage();
    this.nofity = new Notifier();
  }

  async index() {
    try {
      const { data } = await this.client.index();
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      this.nofity.success('Campo criado com sucesso!');
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Campo Customizado');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Campo Customizado');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.client.update(id, data);
      this.nofity.success('Campo atualizado com sucesso!');
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Campo Customizado');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      this.nofity.success('Campo deletado com sucesso!');
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Campo Customizado');
    }
  }
}
